import currencyFormatter from 'currency-formatter';
import { WithStyles } from 'decorators/withStyles';
import { IProductBump } from 'interfaces/orderbump';
import React, { Component } from 'react';

interface IProps {
  classes?: any;
  product: IProductBump;
}

interface IState {}

@WithStyles(() => ({
  image: {
    marginRight: 5,
    width: '50px',
    height: '50px',
    '& img': {
      width: '100%',
      height: '100%',
      objectFit: 'contain'
    }
  },
  productInfo: {
    display: 'flex'
  },
  productDescription: {
    display: 'flex',
    padding: '0 8px',
    alignItems: 'center',
    justifyContent: 'space-between'
  },
  productInvalid: {
    display: 'flex',
    padding: '0 8px'
  },
  title: {
    margin: 0
  },
  price: {
    fontWeight: 500,
    margin: 0,
    alignSelf: 'center'
  },
  productText: {
    flex: 9,
    display: 'flex'
  }
}))
export default class ProductInfo extends Component<IProps, IState> {
  render() {
    const { product } = this.props;
    const { image, productInfo, productDescription, price, title, productText, productInvalid } = this.props.classes;
    const component = !product ? (
      <div className={productInvalid}>
        <p className={title} style={{ color: '#f44336' }}>
          Produto está inválido para Order Bump
        </p>
      </div>
    ) : (
      <div className={productDescription}>
        <div className={productInfo}>
          <div className={image}>
            <img src={product.image} />
          </div>
          <div className={productText}>
            <p className={title}>{product.title}</p>
          </div>
        </div>
        <div>
          <span className={price} style={{ color: '#009358' }}>
            {product.price > 0 ? currencyFormatter.format(product.price, { code: 'BRL', precision: 2 }) : 'Gratuíto'}
          </span>
        </div>
      </div>
    );

    return component;
  }
}
